<template>
  <div :class="['card', $style.card]">
    <div class="row no-gutters">
      <div :class="['col-12', flip ? '' : 'order-1']">
        <slot name="img"/>
      </div>
      <div class="col-12">
        <div
          v-track-click="'Teaser Card'"
          class="card-body"
        >
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeaserCard',
  props: {
    flip: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" module>
.card {
  img {
    height: 100%;
    object-fit: cover;
  }
}
</style>
